import React, { useState, useRef, useContext } from 'react';
import {
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonIcon,
  IonBackButton,
  IonModal,
  IonCard,
  IonCardContent
} from '@ionic/react';

import './AppHeader.css';

import { Notification } from '../models';

import NotificationCard from './NotificationCard';

import AccountHeader from './AccountHeader';
import NotificationsRepository from '../repositories/NotificationsRepository';
import { connect } from 'react-redux';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { ThemeContext } from './theme/ThemeProvider';
import { LaboratoryRootState } from '../store/reducers/laboratory';
import { unilabsHome } from '../const';

const mapStateToProps = (
  state: {
    authentication: AuthenticationRootState;
    laboratory: LaboratoryRootState;
  },
  ownProps: any
) => {
  return {
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken,
    homeLink: state.laboratory.homeLink
  };
};

type Props = {
  defaultBackLink?: string;
  hideBackLink?: boolean;
} & ReturnType<typeof mapStateToProps>;

const AppHeader: React.FC<Props> = ({
  defaultBackLink,
  hideBackLink,
  isLoggedIn
}) => {
  const theme = useContext(ThemeContext);
  const enableNotification = false;
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [isNotificationLoading, setIsNotificationLoading] = useState(false);
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const notificationButton = useRef(null);

  async function showNotification() {
    setIsNotificationLoading(true);
    setShowNotificationModal(true);
    const notifications = await NotificationsRepository.findAll();
    setNotifications(notifications);
    setIsNotificationLoading(false);
  }

  return (
    <IonHeader className="ion-no-border">
      <IonToolbar>
        {!hideBackLink ? (
          <IonButtons slot="start" className="ion-margin-right">
            <IonBackButton text="" defaultHref={defaultBackLink} />
          </IonButtons>
        ) : null}
        <a href={unilabsHome}>
          <img
            src={theme.logo}
            alt="Unilabs"
            height="40"
            className="app-header__logo"
          />
        </a>
        <IonButtons slot="end">
          <div className="ion-custom-hide-md-down">
            <AccountHeader />
          </div>
          {isLoggedIn && enableNotification ? (
            <IonButton
              onClick={() => showNotification()}
              ref={notificationButton as any}
              color="dark"
            >
              <IonIcon
                src={require('../assets/icons/notification.svg')}
              ></IonIcon>
            </IonButton>
          ) : null}
          <IonButton
            className="ion-custom-hide-md-down burger-button"
            onClick={() => {
              document.body.classList.add('menu-open');
            }}
          >
            <IonIcon src={require('../assets/icons/menu.svg')}></IonIcon>
          </IonButton>
        </IonButtons>
        {isLoggedIn && enableNotification ? (
          <IonModal
            cssClass="modal-notification"
            isOpen={showNotificationModal}
            swipeToClose={true}
            presentingElement={(notificationButton as any).current}
            onDidDismiss={() => setShowNotificationModal(false)}
            showBackdrop
            backdropDismiss
          >
            <div className="ion-padding">
              {isNotificationLoading ? (
                <NotificationCard />
              ) : notifications.length ? (
                notifications.map((notification) => (
                  <NotificationCard notification={notification} />
                ))
              ) : (
                <IonCard>
                  <IonCardContent className="ion-text-center">
                    Vous n'avez pas de nouvelle notification
                  </IonCardContent>
                </IonCard>
              )}
            </div>
          </IonModal>
        ) : null}
      </IonToolbar>
    </IonHeader>
  );
};

export default connect(mapStateToProps, null)(AppHeader);
